export class MergeGridRequestModel{
  images  : File[]=[];
  rows:number=1;
  cols:number=1;
  spacing:number=10;
  margin:number=20;
}


export class MergeGridResponseModel{
  base64_image!:string;
  content_type!:string;
}
